import { useCart } from "../context/CartContext";
import { X, Minus, Plus, ShoppingBag, Gift } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

export default function CartDrawer() {
  const { open, setOpen, items, removeItem, updateQty, subtotal } = useCart();
  if (!open) return null;

  return (
    <>
      <div className="fixed inset-0 bg-[#1A1A1A]/40 backdrop-blur-sm z-[70]" onClick={() => setOpen(false)} data-testid="cart-overlay" />
      <aside className="fixed top-0 right-0 h-full w-full sm:w-[440px] bg-[#FAF8F5] z-[80] shadow-2xl flex flex-col fade-up" data-testid="cart-drawer">
        <div className="flex justify-between items-center p-6 border-b border-[#E6DED5]">
          <div className="font-serif text-2xl">Your Bag <span className="text-[#5C5C5C] text-base">({items.length})</span></div>
          <button onClick={() => setOpen(false)} data-testid="close-cart"><X size={20} weight="light" /></button>
        </div>

        {items.length === 0 ? (
          <div className="flex-1 flex flex-col items-center justify-center gap-4 p-8 text-center">
            <ShoppingBag size={48} weight="light" color="#5C5C5C" />
            <p className="font-serif text-2xl">Your bag is empty</p>
            <Link to="/shop" onClick={() => setOpen(false)} className="overline underline underline-offset-4 mt-2" data-testid="cart-shop-link">Start browsing</Link>
          </div>
        ) : (
          <>
            <div className="flex-1 overflow-y-auto p-6 space-y-6">
              {items.map((it, idx) => (
                <div key={idx} className="flex gap-4" data-testid={`cart-item-${idx}`}>
                  <div className="relative w-24 h-32 flex-shrink-0">
                    <img src={it.product.images[0]} alt={it.product.name} className="w-full h-full object-cover" />
                    {it.is_gift && (
                      <div className="absolute top-1 left-1 bg-[#4A1525] text-[#FAF8F5] w-6 h-6 flex items-center justify-center" title="Gift add-on" data-testid={`gift-badge-${idx}`}>
                        <Gift size={12} weight="light" />
                      </div>
                    )}
                  </div>
                  <div className="flex-1 flex flex-col">
                    <div className="flex justify-between gap-2">
                      <div>
                        {it.is_gift && <div className="overline text-[10px] text-[#4A1525] mb-0.5">Gift add-on</div>}
                        <div className="font-serif text-base">{it.product.name}</div>
                        <div className="overline text-[#5C5C5C] mt-1">Size {it.size} · {it.color}</div>
                        {it.is_gift && it.gift_note && (
                          <div className="mt-2 text-xs italic text-[#5C5C5C] border-l-2 border-[#4A1525] pl-2 leading-snug" data-testid={`gift-note-${idx}`}>
                            "{it.gift_note}"
                          </div>
                        )}
                      </div>
                      <button onClick={() => removeItem(idx)} className="text-xs underline underline-offset-4 text-[#5C5C5C] hover:text-[#4A1525]" data-testid={`remove-item-${idx}`}>Remove</button>
                    </div>
                    <div className="flex justify-between items-end mt-auto">
                      <div className="flex items-center border border-[#E6DED5]">
                        <button onClick={() => updateQty(idx, it.quantity - 1)} className="w-8 h-8 flex items-center justify-center" data-testid={`decrease-qty-${idx}`}><Minus size={12} weight="light" /></button>
                        <span className="w-8 text-center text-sm">{it.quantity}</span>
                        <button onClick={() => updateQty(idx, it.quantity + 1)} className="w-8 h-8 flex items-center justify-center" data-testid={`increase-qty-${idx}`}><Plus size={12} weight="light" /></button>
                      </div>
                      <div className="text-sm">₹{(it.product.price * it.quantity).toFixed(0)}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="border-t border-[#E6DED5] p-6 space-y-4">
              <div className="flex justify-between font-serif text-xl">
                <span>Subtotal</span>
                <span data-testid="cart-subtotal">₹{subtotal.toFixed(0)}</span>
              </div>
              <p className="text-xs text-[#5C5C5C]">Shipping and taxes calculated at checkout.</p>
              <Link to="/checkout" onClick={() => setOpen(false)} className="block w-full bg-[#4A1525] text-[#FAF8F5] py-4 text-center overline hover:bg-[#360F1B] transition-colors" data-testid="checkout-btn">
                Checkout
              </Link>
            </div>
          </>
        )}
      </aside>
    </>
  );
}
